import {CardChoice, ChoiceButton, IconProp} from 'ngx-satoris';
import {ValidatorFn} from '@angular/forms';
import {UserPlatformRole} from './user';

//Model to represent each error in the form
export interface FormError {
    key: string;
    keyError: string;
    vars?: { name: string; value: string }[];
    additionalKey?: string;
    icon?: IconProp;
}

//Model to represent the form
export type VisaFormConfig = {
  [key: string]: FormStep;
};

//Model to represent the form names
export enum VisaFormName {
  VISITOR_DETAILS = 'visitor_details',
  REQUIREMENTS = 'requirements',
  PERSONAL_DETAILS = 'personal_details',
  PERSONAL_DETAILS_1 = 'personal_details_1',
  PERSONAL_DETAILS_2 = 'personal_details_2',
  PERSONAL_DETAILS_3 = 'personal_details_3',
  BIOMETRIC_DETAILS = 'biometric_details',
  CONTACT_DETAILS = 'contact_details',
  EMERGENCY_CONTACT = 'emergency_contact',
  TRAVEL_INFORMATION = 'travel_information',
  MISCELLANEOUS_DETAILS = 'miscellaneous_details',
  SPOUSE_DETAILS = 'spouse_details',
  DEPENDANTS = 'dependants',
  DOCUMENT = 'documents_attached',
  APPLICANT_INFORMATION = 'applicant_information',
  APPLIER_INFORMATION = 'applier_information',
  NEXT_KIN = 'next_of_kin',
  DECLARATION = 'declaration'
}

export enum VisaFN {
  CS_IDENTIFIER = 'CSIdentifier',
  PHONE_LOCAL = 'phoneLocal',
  FATHERS_NAME = 'FathersName',
  MOTHERS_NAME = 'MothersName',
  RENEWDOCUMENTFILE = 'RenewDocumentFile',
  RENEWDOCUMENT = 'RenewDocument',
  NO_FEE_PROOF = 'NoFeeProof',
  OTHER_PURPOSE = 'OtherPurpose',
  SPECIAL_PASSPORT_APPROVAL = 'SpecialPassportApproval',
  REGISTRATION_PORT_ID = 'RegistrationPortId',
  PROVISIONAL_ENTRY_PORT = 'ProvisionnalEntryPort',
  ADDRESS_AT_DESTINATION = 'AddressAtDestination',
  ADDRESS_ZIMBABWE = 'AddressZimbabwe',
  PLACE_OF_BIRTH_CITY = 'PlaceOfBirthCity',
  BIRTH_CITY = 'BirthCity',
  AFFIDAVIT_CUSTODY = 'AffidavitCustody',
  APPLICATION_LETTER = 'ApplicationLetter',
  ARRIVAL_DATE = 'ArrivalDate',
  ATTESTANT_ADDRESS = 'AttestantAddress',
  ATTESTANT_DOCUMENT = 'AttestantDocument',
  ATTESTANT_EMAIL = 'AttestantEmail',
  ATTESTANT_ID = 'AttestantID',
  ATTESTANT_NAME = 'AttestantName',
  ATTESTANT_PHONE = 'AttestantPhone',
  ATTESTANT_RELATION = 'AttestantRelation',
  BATCH_ID = 'BatchId',
  BIRTH_DAY = 'BirthDay',
  BIRTH_EXTRACT = 'BirthExtract',
  BUSINESS_LETTER = 'BusinessLetter',
  BUSINESS_PROFILE = 'BusinessProfile',
  CHECKBOX_TERMS_AND_CONDITIONS = 'CheckboxTermsAndConditions',
  CHECKBOX_VISA_EXTEND_FEES = 'CheckboxVisaExtendFees',
  CHECKBOX_VISA_FEES = 'CheckboxVisaFees',
  COMPANIONS_SIZE = 'CompanionsSize',
  COPY_OF_ENTRY = 'CopyOfEntry',
  DATE_OF_EXPIRY = 'DateOfExpiry',
  DATE_OF_ISSUE = 'DateOfIssue',
  DAYS_REQUESTED = 'DaysRequested',
  DEPARTURE_DATE = 'DepartureDate',
  DEPARTURE_TICKET = 'DepartureTicket',
  DEPENDANTS = 'Dependants',
  EMAIL = 'Email',
  EMERGENCY_EMAIL = 'EmergencyEmail',
  EMERGENCY_FIRST_NAME = 'EmergencyFirstName',
  EMERGENCY_LAST_NAME = 'EmergencyLastName',
  EMERGENCY_PHONE = 'EmergencyPhone',
  EXISTING_VALID_ENTRY_REFERENCE = 'ExistingValidEntryReference',
  EXTRA_DOCUMENT_1 = 'ExtraDocument1',
  EXTRA_DOCUMENT_2 = 'ExtraDocument2',
  EXTRA_DOCUMENT_3 = 'ExtraDocument3',
  EXTRA_DOCUMENT_4 = 'ExtraDocument4',
  EXTRA_DOCUMENT_5 = 'ExtraDocument5',
  FIRST_NAME = 'FirstName',
  FUNDS_AVAILABLE = 'FundsAvailable',
  FUNDS_AVAILABLE_CURRENCY = 'FundsAvailableCurrency',
  GENDER = 'Gender',
  HOME_ADDRESS = 'HomeAddress',
  HOST_INVITATION_LETTER = 'HostInvitationLetter',
  HOST_NAME = 'HostName',
  INVITATION_LETTER = 'InvitationLetter',
  INVITATION_LETTER_AND_BUSINESS_PROFILE = 'InvitationLetterAndBusinessProfile',
  EVENT_INVITATION_LETTER = 'EventInvitationLetter',
  LAST_NAME = 'LastName',
  LETTER_OF_ACCEPTANCE_FROM_SCHOOL = 'LetterOfAcceptanceFromSchool',
  MARITAL_STATUS = 'MaritalStatus',
  NATIONALITY = 'Nationality',
  NATIONAL_ID = 'NationalId',
  NATIONALITY_CERTIFICATE = 'NationalityCertificate',
  NEXT_OF_KIN = 'NextOfKin',
  NNI = 'NNI',
  NON_ORDINARY_PASS_MISSION = 'NonOrdinaryPassMission',
  OCCUPATION = 'Occupation',
  OTHER_NAME = 'OtherName',
  PARENTAL_APPROVAL = 'ParentalApproval',
  PASSPORT_COUNTRY = 'PassportCountry',
  PASSPORT_NUMBER = 'PassportNumber',
  PASSPORT_PHOTO = 'PassportPhoto',
  PASSPORT_SCAN = 'PassportScan',
  PASSPORT_TYPE = 'PassportType',
  PHONE = 'Phone',
  PHOTO = 'Photo',
  PLACE_OF_BIRTH = 'PlaceOfBirth',
  PLACE_OF_BIRTH_COUNTRY = 'PlaceOfBirthCountry',
  BIRTH_COUNTRY = 'BirthCountry',
  COUNTRY_OF_BIRTH = 'CountryOfBirth',
  PLACE_OF_ISSUE = 'PlaceofIssue',
  PREVIOUS_CONVICTIONS_HOME = 'PreviousConvictionsHome',
  PREVIOUS_CONVICTIONS_HOME_ASK = 'PreviousConvictionsHomeAsk',
  PREVIOUS_CONVICTIONS_ZIM = 'PreviousConvictionsZim',
  PREVIOUS_CONVICTIONS_ZIM_ASK = 'PreviousConvictionsZimAsk',
  PREVIOUS_PASSPORT_NUMBER = 'PreviousPassportNumber',
  PREVIOUS_ZIMBABWEAN_VISA = 'PreviousZimbabweanVisa',
  PROOF_OF_RESIDENCE = 'ProofOfResidence',
  PROOF_OF_RESIDENCE_HOST = 'ProofOfResidenceHost',
  PURPOSE_OF_VISIT = 'PurposeOfVisit',
  REASON_FOR_EXTENSION = 'ReasonForExtension',
  REASON_OF_VISIT_PROOF = 'ReasonOfVisitProof',
  REFERENCE_PREVIOUS_VISA = 'ReferencePreviousVisa',
  RESIDENCE_CERTIFICATE = 'ResidenceCertificate',
  RESIDENCE_PERMIT_NUMBER = 'ResidencePermitNumber',
  RESIDENT_PERMIT_TYPE = 'ResidentPermitType',
  RESIDENTIAL_STATUS_OF_HOST = 'ResidentialStatusOfHost',
  SPOUSE = 'Spouse',
  SPOUSE_DATE_OF_BIRTH = 'SpouseBirthDay',
  SPOUSE_NAME = 'SpouseFullName',
  SPOUSE_PASSPORT_NUMBER = 'SpousePassportNumber',
  SPOUSE_PLACE_OF_BIRTH = 'SpousePlaceOfBirth',
  URGENT = 'Urgent',
  USAGE_AFTER = 'UsageAfter',
  USAGE_UNTIL = 'UsageUntil',
  VISA_REFERENCE = 'VisaReference',
  VISA_TYPE = 'VisaType',
  ISLAND_ORIGIN = 'IslandOrigin',
  INDICATIVE_PHONE = 'IndicatifTelephoneNumber',
  MAIDEN_NAME = 'MaidenName',
  ADDRESS_LINE_1 = 'AddressLine1',
  ADDRESS_LINE_2 = 'AddressLine2',
  ADDRESS_LINE_3 = 'AddressLine3',
  HAIR_COLOR = 'HairColor',
  EYE_COLOR = 'EyeColor',
  MOTHER_FIRST_NAME = 'MotherFirstName',
  MOTHER_LAST_NAME = 'MotherLastName',
  MOTHER_PLACE_OF_BIRTH = 'MotherPlaceOfBirth',
  MOTHER_COUNTRY_OF_BIRTH = 'MotherCountryOfBirth',
  FATHER_FIRST_NAME = 'FatherFirstName',
  FATHER_LAST_NAME = 'FatherLastName',
  FATHER_PLACE_OF_BIRTH = 'FatherPlaceOfBirth',
  FATHER_COUNTRY_OF_BIRTH = 'FatherCountryOfBirth',
  HEIGHT = 'Height',
  BIRTH_EXTRACT_NUMBER = 'BirthExtractNumber',
  DRIVER_LICENSE_NUMBER = 'DriverLicenseNumber',
  REGISTRATION_TYPE = 'RegistrationType',
  PASSPORT_URGENT_DELIVERY = 'PassportUrgentDelivery',
  COUNTRY_OF_RESIDENCE = 'CountryOfResidence',
  SECOND_NATIONALITY = 'SecondNationality',
  PARENT_GUARDIAN_CONSENT = 'ParentGuardianConsent',
  PARENT_GUARDIAN_NAME = 'ParentGuardianName',
  PARENT_GUARDIAN_EMAIL = 'ParentGuardianEmailAddress',
  PARENT_GUARDIAN_TELEPHONE = 'ParentGuardianTelephoneNumber',
  REGION = 'Region',
  PREFECTURE = 'Prefecture',
  SUB_PREFECTURE = 'SubPrefecture',
  COMMUNE = 'Commune',
  POSTAL_CODE = 'PostalCode',
  MODE_OF_TRAVEL = 'ModeOfTravel',
  FLIGHT_NUMBER = 'FlightNumber',
  SHIP_NUMBER = 'ShipNumber',
  CAR_NUMBER = 'CarNumber',
  BUS_NUMBER = 'BusNumber',
  TRAIN_NUMBER = 'TrainNumber',
  ADDRESS = 'Address',
  PREVIOUS_CONVICTIONS_ASK = 'PreviousConvictionsAsk',
  PREVIOUS_CONVICTIONS = 'PreviousConvictions',
  DURATION_OF_STAY = 'DurationOfStay',
  APPLICATION_FORM = 'ApplicationForm',
  BIRTH_CERTIFICATE = 'BirthCertificate',
  PARENTAL_AUTHORIZATION = 'ParentalAuthorization',
  REQUEST_REASON = 'RequestReason',
  ID_CARD_SCAN = 'IdCardScan',
  IDENTIFICATION_DOCUMENT = 'IdentificationDocument',
  GUARDIAN_ID_CARD = 'GuardianIdCard',
  AUTHORIZATION_FORM = 'AuthorizationForm',
  APPROVED_MISSION_ORDER = 'ApprovedMissionOrder',
  IDENTIFICATION_SHEET = 'IdentificationSheet',
  LOSS_DECLARATION = 'LossDeclaration',
  RESIDENCE_PERMIT = 'ResidencePermit',
  WORK_CONTRACT = 'WorkContract',
  EMPLOYER_COMMITMENT_FORM = 'EmployerCommitmentForm',
  MANAGER_JOB_TITLE = 'ManagerJobTitle',
  IDENTITY_PHOTO = 'IdentityPhoto',
  BUSINESS_REGISTRATION_NUMBER = 'BusinessRegistrationNumber',
  COMPANY_NAME = 'CompanyName',
  STATUS = 'Status',
  ID_NUMBER = 'IdNumber',
  BIRTH_ENTRY_NUMBER = 'BirthEntryNumber',
  NAME_CHANGED = 'NameChanged',
  ORIGINAL_NAME = 'OriginalName',
  NAME_CHANGED_TO = 'NameChangedTo',
  NAME_CHANGE_DATE = 'NameChangeDate',
  VISIBLE_MARK = 'VisibleMark',
  MARRIAGE_DATE = 'MarriageDate',
  MARRIAGE_PLACE = 'MarriagePlace',
  MARRIAGE_COUNTRY = 'MarriageCountry',
  MARRIAGE_DIVORCE_ORDER_NUMBER = 'MarriageDivorceOrderNumber',
  SPOUSE_CITIZENSHIP = 'SpouseCitizenship',
  FULL_NAME = 'FullName',
  RELATIONSHIP = 'Relationship',
  ZIMBABWE_CITIZENSHIP = 'ZimbabweCitizenship',
  ZIMBABWE_PASSPORT_ISSUED = 'ZimbabwePassportIssued',
  HOLDING_FOREIGN_PASSPORT = 'HoldingForeignPassport',
  RENOUNCE_FOREIGN_BIRTH_RIGHT = 'RenounceForeignBirthRight',
  SURRENDER_FOREIGN_PASSPORT = 'SurrenderForeignPassport',
  TRUE_INFORMATION_DECLARATION = 'TrueInformationDeclaration',
  MARRIAGE_CERTIFICATE = 'MarriageCertificate',
  CITIZENSHIP_CERTIFICATE = 'CitizenshipCertificate',
  OLD_PASSPORT_OR_EMERGENCY_TRAVEL_DOCUMENT = 'OldPassportOrEmergencyTravelDocument',
  ID_PHOTO = 'IDPhoto',
  FINGERPRINTS = 'Fingerprints',
  SIGNATURE = 'Signature',
  FORM_DEMAND = 'FormDemand',
  MANAGER_JOB_TITLE_OTHER = 'ManagerJobTitleOther',
  STATUS_OTHER = 'StatusOther',
  ATTESTANT_RELATION_OTHER = 'AttestantRelationOther',
  REQUEST_REASON_OTHER = 'RequestReasonOther',
  CR_NNI = 'CRNNI',
  CR_NNI_EXPIRY_DATE = 'CRNNIExpiryDate',
  PREVIOUS_VISA = 'PreviousVisa',
  INVITING_COMPANY_NAME = 'InvitingCompanyName',
  GUARDIAN_LAST_NAME = 'GuardianLastName',
  GUARDIAN_FIRST_NAME = 'GuardianFirstName',
  GUARDIAN_MAIDEN_NAME = 'GuardianMaidenName',
  GUARDIAN_BIRTH_DAY = 'GuardianBirthDay',
  GUARDIAN_IDENTIFICATION_DOCUMENT = 'GuardianIdentificationDocument',
  GUARDIAN_CR_NNI = 'GuardianCRNNI',
  GUARDIAN_CR_NNI_EXPIRY_DATE = 'GuardianCRNNIExpiryDate',
  GUARDIAN_OCCUPATION = 'GuardianOccupation',
  GUARDIAN_ADDRESS = 'GuardianAddress',
  GUARDIAN_PHONE = 'GuardianPhone',
  GUARDIAN_EMAIL = 'GuardianEmail',
  GUARDIAN_MANAGER_LAST_NAME = 'GuardianManagerLastName',
  GUARDIAN_MANAGER_FIRST_NAME = 'GuardianManagerFirstName',
  GUARDIAN_MANAGER_ADDRESS = 'GuardianManagerAddress',
  GUARDIAN_MANAGER_PHONE = 'GuardianManagerPhone',
  GUARDIAN_MANAGER_EMAIL = 'GuardianManagerEmail',
  EMPLOYMENT_CERTIFICATE = 'EmploymentCertificate',
  GUARDIAN_MANAGER_MAIDEN_NAME = 'GuardianManagerMaidenName',
  GUARDIAN_MANAGER_BIRTH_DAY = 'GuardianManagerBirthDay',
  GUARDIAN_MANAGER_IDENTIFICATION_DOCUMENT = 'GuardianManagerIdentificationDocument',
  GUARDIAN_MANAGER_CR_NNI = 'GuardianManagerCRNNI',
  GUARDIAN_MANAGER_CR_NNI_EXPIRY_DATE = 'GuardianManagerCRNNIExpiryDate'
}

export type VisaFNLocal = 'reason';

//Model to represent each field in the form
export interface FormField {
  name: string;
  type: 'text' | 'number' | 'password' | 'email' | 'textarea' | 'select'|
  'tel' | 'date' | 'pin' | 'datetime-local' | 'file' | 'checkbox' | 'choice' |
  'calendar' | 'card' | 'fingerprints' | 'signature' | 'id_photo' | 'scanDoc' | 'dateRange';
  validators?: (ValidatorFn | string)[];
  asyncValidators?: boolean;
  onlyCustomValidators?: boolean;
  mustBeDifferentThan?: {array?: any[], value?: any};
  enum?: any[];
  disabled?: boolean;
  icon?: IconProp;
  customExplain?: string;
  hidden?: boolean;
  value?: any;
  customClass?: string;
  buttonField?: FormStep['buttons'][0];
  ifFormControl?: string;
  ifFormControlHasValue?: {control: VisaFN | VisaFN[] | VisaFNLocal, value?: any};
  ifFormControlHasNotValue?: {control: VisaFN, value?: any};
  alwaysVisible?: boolean;
  requiredIfFormControl?: boolean;
  requiredIfFormControlHasValue?: {control: VisaFN | VisaFN[], value?: any};
  label?: string;
  disclaimer?: string;
  dependants?: FormField[][];
  updateField?: boolean;
  fileName?: string;
  acceptType?: string;
  tooltip?: string;
  dateValidators?: {
    maxDateMilliFrom?: {control: VisaFN, milliseconds: number},
    minDateMilliFromNow?: number,
    maxDateMilliFromNow?: number,
    maxDateMilliTo?: {control: VisaFN, milliseconds: number},
    maxDateMilliFromToday?: number,
    mustBeEqualOrBefore?: {form: VisaFormName, control: VisaFN},
    mustBeEqualOrAfter?: {form: VisaFormName, control: VisaFN},
    maxDate?: string,
    minDate?: string,
  };
  action?: FormAction;
  topDivider?: boolean;
  bottomDivider?: boolean;
  showInResume?: boolean;
  maxFileSize?: number;
  maxLength?: number;
  textareaRows?: number;
  noAutocomplete?: boolean;
  choiceButtons?: ChoiceButton[],
  cardChoice?: CardChoice[];
  sameRow?: string;
  pattern?: string;
  minimum?: number;
  maximum?: number;
  ifFormControlHasMinDateMilliFromNow?: {form: VisaFormName, control: VisaFN, value: number};
  requireOneOf?: VisaFN[];
  style?: {[key: string]: string};
  classNames?: string;
  preValue?: string | number | boolean; // Clear upon coming again on form
  defaultValue?: string | number | boolean; // Only used if no set value (kept upon coming again)
  trimSet?: string; // Other characters to be trimmed
  transform?: (value: string) => string;
}

//Model to represent each step of the form
export interface FormStep {
  version: number;
  fields?: FormField[];
  requiredList?: {icon: IconProp, text: string}[];
  visaPrice?: boolean;
  visaPriceText?: string;
  textBeforeForm?: {title?: string, text?: string};
  buttons?: {icon?: IconProp, text: string, action: FormAction, needAllFields : boolean, customClass?: string, size?: string}[];
  errors?: FormError[];
  hasRevisionErrors?: boolean;
  visited?: boolean;
  submitted?: boolean;
  classNames?: string;
  imagePay ?: boolean;
  disabledForRoles?: UserPlatformRole[];
  disabledForSeniorities?: number[];
  toBeRemoved?: boolean;
}

export enum FormAction {
  NEWBATCHID = 1,
  UPDATE = 2,
  PAYMENT = 3,
  SUBMIT = 4,
  FOCUS_BLUR = 5,
  SAVE = 6,
  UPLOAD_FILE = 7,
  SELECT_PASSPORT_TYPE = 8,
}

export enum Direction {
  NEXT = 'next',
  PREVIOUS = 'previous'
}

export interface SelectOption {
  value: string;
  name: string;
}

export const TRAVEL_NUM_BY_MODE: Record<string, VisaFN> = {
  flight: VisaFN.FLIGHT_NUMBER,
  train: VisaFN.TRAIN_NUMBER,
  bus: VisaFN.BUS_NUMBER,
  ship: VisaFN.SHIP_NUMBER,
  car: VisaFN.CAR_NUMBER
};
